import '@/styles/main.scss';
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import { aliases, fa } from 'vuetify/iconsets/fa-svg';
import { afTheme } from './theme';
import ExpandIcon from '@/components/select/ExpandIcon.vue';
import { shallowRef } from 'vue';
import CollapseIcon from '@/components/select/CollapseIcon.vue';

const expandComponent = shallowRef(ExpandIcon);
const collapseComponent = shallowRef(CollapseIcon);

export default createVuetify({
  locale: {
    rtl: { ar: true },
  },
  defaults: {
    VAutocomplete: {
      menuProps: { maxHeight: 240 },
      menuIcon: expandComponent,
      variant: 'outlined',
      rounded: null,
      bgColor: 'surface',
      singleLine: true,
      hideDetails: 'auto',
      density: 'comfortable',
    },
    VBtn: {
      rounded: 'pill',
    },
    VChip: {
      variant: 'outlined',
      rounded: 'pill',
    },
    VCheckbox: {
      color: 'primary',
      falseIcon: 'fat fa-square',
      density: 'compact',
    },
    VCombobox: {
      variant: 'outlined',
      rounded: null,
      density: 'compact',
    },
    VDivider: {
      color: 'border',
    },
    VListGroup: {
      expandIcon: expandComponent,
      collapseIcon: collapseComponent,
    },
    VProgressLinear: {
      bgColor: 'empty',
      bgOpacity: '1',
      height: '12',
      rounded: 'pill',
      roundedBar: true,
    },
    VSelect: {
      menuProps: { maxHeight: 240 },
      menuIcon: expandComponent,
      variant: 'outlined',
      rounded: null,
      bgColor: 'surface',
      singleLine: true,
      hideDetails: 'auto',
      density: 'comfortable',
    },
    VTab: {
      VBtn: {
        rounded: 0,
      },
    },
    VTabs: {
      sliderColor: 'primary',
    },
    VTextField: {
      variant: 'outlined',
      rounded: null,
      density: 'comfortable',
      bgColor: 'surface',
      hideDetails: 'auto',
    },
    VTextarea: {
      variant: 'outlined',
    },
  },
  icons: {
    defaultSet: 'fa',
    aliases: {
      ...aliases,
      radioOn: 'fas fa-circle-dot',
      radioOff: 'fat fa-circle',
      checkboxOn: 'fas fa-square-check',
      checkboxOff: 'fat fa-square',
    },
    sets: {
      fa,
    },
  },
  theme: {
    defaultTheme: 'afTheme',
    themes: {
      afTheme,
    },
  },
});
